<div class="risk-group-form-container" fxFlex="100" fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row" fxLayoutGap="15px">
    <button
      (click)="addGroup()"
      mat-stroked-button
      color="accent"
    >
      <mat-icon>add</mat-icon>
      <span> Dodaj grupę</span></button>

    <button
      (click)="save()" [class.spinner]="processingRequest"
      [disabled]="processingRequest || !formGroupsValid"
      mat-stroked-button color="primary"
    >
      <mat-icon>save</mat-icon>
      <span> Zapisz</span></button>

    <button
      (click)="cancel()"
      mat-stroked-button
      color="warn"
    >
      <mat-icon>cancel</mat-icon>
      <span> Anuluj</span></button>
  </div>

  <div fxLayout="column" fxLayoutGap="15px" fxFlex="100" *ngFor="let formGroup of formGroups.controls; index as i"
       [formGroup]="$any(formGroup)">

    <mat-card class="mat-elevation-z4" fxFlex="100" fxLayout="column" fxLayoutGap="15px">
      <h3>Grupa</h3>
      <div fxLayout="row">
        <div fxFlex="100">
          <app-chips-input-control fxFlex label="Kody grupy"
                                   [arrayControl]="$any(formGroup.get('groupNames'))"></app-chips-input-control>
        </div>
      </div>

      <h4>Ryzyka</h4>

      <ng-container formArrayName="risks">
        <ng-container *ngFor="let riskFormGroup of $any(formGroup.get('risks')).controls; index as i"
                      [formGroup]="riskFormGroup">
          <div
            fxFlex="100"
            fxLayout="column"
            fxLayoutGap="15px"
            class="mat-elevation-z2 risk-record-container"
          >

            <!-- ========================= -->
            <!-- DANE PODSTAWOWE RYZYKA -->
            <!-- ========================= -->

            <div
              fxLayout="row"
              fxLayoutGap="15px"
              fxLayoutAlign="start end"
            >

              <div
                fxFlex="25px"
                class="list-counter"
              >
                <span>{{ i + 1 }}.</span>
              </div>

              <div fxFlex>
                <mat-form-field fxFlex>
                  <mat-label>Kod ryzyka</mat-label>

                  <input
                    matInput
                    placeholder="Kod ryzyka"
                    formControlName="name"
                  >
                </mat-form-field>
              </div>

              <div fxFlex>
                <mat-form-field fxFlex>
                  <mat-label>Nazwa ryzyka</mat-label>

                  <input
                    matInput
                    placeholder="Nazwa ryzyka"
                    formControlName="riskName"
                  >
                </mat-form-field>
              </div>

              <div fxFlex>
                <mat-form-field fxFlex>
                  <mat-label>Riders</mat-label>

                  <input
                    matInput
                    placeholder="OC, AC, Assistance"
                    formControlName="riders"
                  >
                </mat-form-field>
              </div>

              <div fxFlex>
                <app-dict
                  label="Typ polisy"
                  dictType="sold_policy_type"
                  [control]="riskFormGroup.get('policyType')"
                  fxFlex
                ></app-dict>
              </div>

              <div
                fxFlex="135px"
                fxLayout="row"
                fxLayoutAlign="end end"
                class="actions-container"
              >

                <button
                  (click)="addRiskRate(
          $any(riskFormGroup.get('customRates')),
          null,
          TYPE_PARTNERS
        )"
                  mat-icon-button
                  color="accent"
                  matTooltip="Dodaj aneks"
                >
                  <mat-icon>receipt_long</mat-icon>
                </button>

                <button
                  (click)="addRiskRate(
          $any(riskFormGroup.get('customRates')),
          null,
          TYPE_THRESHOLD
        )"
                  mat-icon-button
                  color="accent"
                  matTooltip="Dodaj próg"
                >
                  <mat-icon>data_thresholding</mat-icon>
                </button>

                <button
                  (click)="removeRisk($any(formGroup), i)"
                  mat-icon-button
                  color="warn"
                  matTooltip="Usuń ryzyko"
                >
                  <mat-icon>delete</mat-icon>
                </button>

              </div>

            </div>

            <!-- ========================= -->
            <!-- STAWKI -->
            <!-- ========================= -->

            <div class="risk-rates-row-wrapper">

              <div
                class="risk-rates-row"
                fxLayout="row"
                fxLayoutGap="15px"
                fxLayoutAlign="start end"
              >

                <div
                  fxFlex="25px"
                  class="list-counter"
                ></div>

                <!-- STAWKI TU -->
                <div fxFlex class="risk-rate-field">

                  <app-chips-input-control
                    fxFlex
                    label="Stawki % TU"
                    [arrayControl]="riskFormGroup.get('rates')"
                  ></app-chips-input-control>

                </div>

                <!-- LEGACY -->
                <div fxFlex class="risk-rate-field">

                  <mat-form-field fxFlex>
                    <mat-label>Stawka % Partner LEGACY</mat-label>

                    <input
                      matInput
                      placeholder="Legacy"
                      formControlName="ratePaid"
                      matTooltip="Stara stawka Risk.ratePaid"
                    >
                  </mat-form-field>

                </div>

                <!-- DYNAMICZNE TABELE -->
                <ng-container>
                  <div fxFlex class="risk-rate-field"
                    *ngFor="let commissionRateFormGroup  of getVisibleCommissionRateForms(riskFormGroup)"  [formGroup]="commissionRateFormGroup"
                  >
                    <mat-form-field fxFlex>
                      <mat-label>
                        {{getCommissionTable(
                            commissionRateFormGroup
                              .get('commissionTable')
                              .value
                          )?.shortName
                        }}
                      </mat-label>

                      <input
                        matInput
                        formControlName="ratePaid"
                        [placeholder]="getCommissionTable(commissionRateFormGroup.get('commissionTable').value)?.shortName"
                      >

                    </mat-form-field>

                  </div>

                </ng-container>

                <!-- miejsce odpowiadające akcjom z pierwszego rzędu -->
                <div fxFlex="135px"></div>

              </div>

            </div>

            <!-- ========================= -->
            <!-- ANEKSY -->
            <!-- ========================= -->

            <div
              fxFlex="100"
              fxLayout="column"
              fxLayoutGap="15px"
            >

              <ng-container *ngFor="let riskRateFormGroup of getRiskRatesForms(riskFormGroup, TYPE_PARTNERS);  index as i"
                            [formGroup]="riskRateFormGroup"
              >

                <div
                  fxLayout="row"
                  fxLayoutGap="15px"
                  fxLayoutAlign="space-around end"
                >

                  <div fxFlex></div>

                  <div
                    fxFlex="55px"
                    class="list-counter"
                  >
                    <span>Aneks {{ i + 1 }}.</span>
                  </div>

                  <app-dict-partners-chips
                    fxFlex="50"
                    fxFlex.lt-md="66"
                    label="Partnerzy"
                    [control]="$any(riskRateFormGroup.get('partners'))"
                    [required]="false"
                  ></app-dict-partners-chips>

                  <div fxFlex>
                    <mat-form-field fxFlex>
                      <mat-label>Stawka % Partner</mat-label>

                      <input
                        matInput
                        placeholder="Stawka % Partner"
                        formControlName="ratePaid"
                      >
                    </mat-form-field>
                  </div>

                  <div
                    fxLayout="row"
                    fxLayoutAlign="space-around end"
                    class="actions-container"
                  >
                    <button
                      (click)="removeRiskRate(
              $any(riskFormGroup),
              $any(riskRateFormGroup)
            )"
                      mat-icon-button
                      color="warn"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>

                </div>

              </ng-container>

              <!-- ========================= -->
              <!-- PROGI -->
              <!-- ========================= -->

              <ng-container
                *ngFor="
        let riskRateFormGroup
          of getRiskRatesForms(riskFormGroup, TYPE_THRESHOLD);
        index as i
      "
                [formGroup]="riskRateFormGroup"
              >

                <div
                  fxLayout="row"
                  fxLayoutGap="15px"
                  fxLayoutAlign="space-around end"
                >

                  <div fxFlex></div>

                  <div
                    fxFlex="55px"
                    class="list-counter"
                  >
                    <span>Próg {{ i + 1 }}.</span>
                  </div>

                  <div
                    fxFlex="50"
                    fxFlex.lt-md="66"
                    fxLayoutGap="15px"
                  >

                    <div fxFlex="50">
                      <mat-form-field fxFlex>
                        <mat-label>Suma od</mat-label>

                        <input
                          matInput
                          placeholder="Suma od"
                          formControlName="thresholdFrom"
                        >
                      </mat-form-field>
                    </div>

                    <div fxFlex="50">
                      <mat-form-field fxFlex>
                        <mat-label>Suma do</mat-label>

                        <input
                          matInput
                          placeholder="Suma do"
                          formControlName="thresholdTo"
                        >
                      </mat-form-field>
                    </div>

                  </div>

                  <div fxFlex>
                    <mat-form-field fxFlex>
                      <mat-label>Stawka % Partner</mat-label>

                      <input
                        matInput
                        placeholder="Stawka % Partner"
                        formControlName="ratePaid"
                      >
                    </mat-form-field>
                  </div>

                  <div
                    fxLayout="row"
                    fxLayoutAlign="space-around end"
                    class="actions-container"
                  >
                    <button
                      (click)="removeRiskRate(
              $any(riskFormGroup),
              $any(riskRateFormGroup)
            )"
                      mat-icon-button
                      color="warn"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>

                </div>

              </ng-container>

            </div>

          </div>
        </ng-container>

        <div fxLayout="row" fxLayoutGap="15px">
          <button
            (click)="addRisk($any(formGroup.get('risks')))"
            mat-stroked-button
            color="accent"
          >
            <mat-icon>add</mat-icon>
            <span> Dodaj ryzyko</span></button>

          <span fxFlex></span>

          <button
            (click)="removeGroup(i)"
            mat-stroked-button color="warn"
          >
            <mat-icon>delete</mat-icon>
            <span> Usuń grupę</span></button>
        </div>
      </ng-container>
    </mat-card>

  </div>
</div>
